import { Component, OnInit } from '@angular/core';
import { TipRadneOpreme } from './tip-radne-opreme';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-tip-radne-opreme',
  templateUrl: './tip-radne-opreme.component.html'
})
export class TipRadneOpremeComponent 
extends BaseModalContainer<TipRadneOpreme> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<TipRadneOpreme>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService

  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
